<div class="flex-control flex-column flex-height" *ngIf="program && program.id">
  <app-program-enrolled-header class="flex-header" [program]="program"></app-program-enrolled-header>
  <app-program-enrolled-patients class="flex-body" [program]="program" ></app-program-enrolled-patients>
</div>
